//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ["Data1","Data2","Data3"],
	data() {
		return {
			today:'',
			history:'',
			list:'',
			flag:false,
			num:0,
			imgUrl:'https://hxfile.shyunhua.com/',
			timer:''
		};
	},
	watch:{
		Data1(){
			this.today=this.Data1
		},
		Data2(){
			this.history=this.Data2
		},
		Data3(){
			this.num=0
			if(this.Data3.length>0){
				this.list=this.Data3[0]
				// console.log(this.list.card[16],'9999')
			}

		}
	},
	created(){

	},
	mounted() {
		var that=this;
		that.timer=setInterval(() => {
			if(that.num<that.Data3.length-1){
				that.num++
				that.list=that.Data3[that.num]
			}else{
				if(that.num>0){
					that.num--
					that.list=that.Data3[that.num]
				}
			}
		},5*1000);

	},
	destroyed(){

		clearInterval(this.timer)
	},

}



// WEBPACK FOOTER //
// ./src/components/shishi.vue